<template>
    <v-container v-scroll="this.onScroll" class="col-12 col-md-6 col-sm-10">
      <v-progress-linear
        :value="scrollPercent"
        absolute
        top
        fixed
        height="5"
        class="reading-progress" />
      <v-row>
        <v-col cols="12">
          <h1>
            {{ articleDetails.data.title[0].text }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-list-item class="pl-0">
            <v-list-item-avatar color="primary">
              <v-img src="../assets/Navigate_symbol_no_background_RGB_small.png" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="">
                {{ $t('common.author')}}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ articleDetails.last_publication_date | formatUTCLocalDate }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip outlined color="pink" class="text-uppercase">
                {{ articleDetails.data.type }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>
          <hr/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <prismic-rich-text :field="articleDetails.data.content" />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Article',
  data: () => ({
    articleDetails: '',
    scrollPercent: 0,
  }),
  methods: {
    getArticleDetails() {
      console.log('getting article details');
      this.$prismic.client.getByID(this.$route.params.id).then((res) => {
        this.articleDetails = res;
      });
    },
    onScroll() {
      const h = document.documentElement; const b = document.body; const st = 'scrollTop';
      const sh = 'scrollHeight';
      this.scrollPercent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight - 300) * 100;
    },
  },
  created() {
    this.getArticleDetails();
  },
};
</script>

<style>
  .reading-progress {
    z-index: auto;
    top: 56px !important;
  }
  p img {
    width: 100% !important;
  }

</style>
